/**
 * ⚠️ PLACEHOLDER CONTENT — NOT REAL RESULTS.
 *
 * Every number and date in this file is a dummy value so the new design can be built
 * and reviewed. Replace each one with real figures (e.g. from Relay / client reports) before
 * this goes live. Search the codebase for `IS_PLACEHOLDER` to find where they are shown.
 */
export const IS_PLACEHOLDER = true;

/** Homepage results strip: 3 headline numbers. */
export const HOME_RESULTS = [
  { value: 48, suffix: 'M+', label: 'organic views generated for clients', period: 'last 12 months' },
  { value: 3.2, suffix: 'x', decimals: 1, label: 'average growth in inbound leads', period: 'within 6 months' },
  { value: 120, suffix: '+', label: 'brands launched, rebuilt or scaled', period: 'since 2020' },
];

/** Results ticker: short dated wins, newest first. */
export const RESULTS_TICKER = [
  { client: 'Partywalas', text: '+212% bulk orders from Instagram', date: 'Aug 2026' },
  { client: 'Junction 14', text: '1.4M reel views in 30 days', date: 'Jul 2026' },
  { client: 'Senyora', text: '4.1x ROAS on Meta ads', date: 'Jul 2026' },
  { client: 'The Burj', text: 'Sold-out Saturdays, 6 weeks straight', date: 'Jun 2026' },
  { client: 'Phylaxis.ai', text: '9,800 app sign-ups from one campaign', date: 'May 2026' },
  { client: 'Pakkey Rang', text: '+68% website sessions after rebrand', date: 'Apr 2026' },
];

/**
 * Case study results, keyed by case study slug. Shown as the results row at the top of each
 * case study and as the result headline on Work cards / story mode.
 * Each: 3 metrics with before -> after and a timeframe.
 */
export const CASE_STUDY_RESULTS = {
  partywalas: {
    headline: '+212% bulk orders from Instagram',
    timeframe: 'in 5 months',
    metrics: [
      { label: 'Monthly bulk orders', before: '34', after: '106' },
      { label: 'Instagram reach / month', before: '18K', after: '410K' },
      { label: 'Cost per lead', before: '₹420', after: '₹138' },
    ],
  },
  junction14: {
    headline: '1.4M reel views in 30 days',
    timeframe: 'in 3 months',
    metrics: [
      { label: 'Reel views / month', before: '22K', after: '1.4M' },
      { label: 'Weekend table bookings', before: '60', after: '190' },
      { label: 'Google rating', before: '4.1', after: '4.6' },
    ],
  },
  senyora: {
    headline: '4.1x return on ad spend',
    timeframe: 'in 4 months',
    metrics: [
      { label: 'ROAS on Meta ads', before: '1.3x', after: '4.1x' },
      { label: 'Online orders / month', before: '210', after: '780' },
      { label: 'Followers', before: '6K', after: '41K' },
    ],
  },
  burj: {
    headline: 'Sold-out Saturdays, 6 weeks straight',
    timeframe: 'in 2 months',
    metrics: [
      { label: 'Saturday footfall', before: '240', after: '650' },
      { label: 'Event page RSVPs', before: '90', after: '1,150' },
      { label: 'Instagram reach / month', before: '35K', after: '920K' },
    ],
  },
  phylaxisai: {
    headline: '9,800 sign-ups from one campaign',
    timeframe: 'in 6 weeks',
    metrics: [
      { label: 'App sign-ups', before: '1,200', after: '9,800' },
      { label: 'Cost per install', before: '₹96', after: '₹31' },
      { label: 'Weekly active users', before: '800', after: '4,300' },
    ],
  },
  'pakkey-rang': {
    headline: '+68% website sessions after rebrand',
    timeframe: 'in 4 months',
    metrics: [
      { label: 'Website sessions / month', before: '5.2K', after: '8.7K' },
      { label: 'Repeat customers', before: '11%', after: '27%' },
      { label: 'Average order value', before: '₹1,450', after: '₹2,100' },
    ],
  },
};

/** Fallback for case studies without an entry above. */
export const DEFAULT_CASE_STUDY_RESULT = {
  headline: 'Brand, content and growth, end to end',
  timeframe: 'in 3 months',
  metrics: [
    { label: 'Monthly reach', before: '20K', after: '350K' },
    { label: 'Inbound leads / month', before: '15', after: '60' },
    { label: 'Engagement rate', before: '1.2%', after: '4.8%' },
  ],
};

/** One-line outcome per service (no prices: the site doesn't publish pricing). */
export const SERVICE_OUTCOMES = {
  'social-media': 'Show up daily, turn followers into customers',
  branding: 'A brand people remember and trust',
  design: 'Creatives that stop the scroll and sell',
  'web-development': 'A fast site that turns visits into leads',
  marketing: 'One plan across ads, content and channels',
};

/** Results for a case study, or null when we haven't published figures for that client yet. */
export function getCaseStudyResult(slug) {
  return CASE_STUDY_RESULTS[slug] || null;
}
